/*
* Palo Alto Theme
*
* Use this file to add faq Javascript to Palo Alto.  Keeping your faq
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the faq.js script import line near the bottom of the file.
*/
jQuery(document).ready(function($) {
    $('.FaqSummary__Item').click(function () {
       $(this).siblings().removeClass('is-active');
       $(this).addClass('is-active');
    })
                                 
     $('.Faq__AnswerWrapper').hide();
     $('.Faq__Question').on('click',function(e){
        e.preventDefault();
            if ( !$(this).hasClass("active") ) {
                $('.Faq__Question').removeClass("active");
                $('.Faq__AnswerWrapper').hide();
                $(this).toggleClass('active');
                $(this).next().slideToggle();
            }   
            else{
                $(this).toggleClass('active');
                $(this).next().slideToggle();
            }      
    });
});



